export const FlashMessagesFilters = {
    ADD: 'IN_MEMORY.FLASH_MESSAGES.ADD',
};

export const add = (severity, i18nKey) => ({
    type: FlashMessagesFilters.ADD,
    severity, i18nKey
});
